import { render } from 'solid-js/web';
// solid-devtools instruments Solid component boundaries for the browser
// extension. The package's export conditions resolve to an empty noop unless
// the `development` condition is active, so a static import ships zero bytes in
// production/staging builds — no DEV guard needed (EID-111).
import 'solid-devtools';
import { Renderer } from 'framework';

import '../style/index.css';
import { version } from '../../../package.json';

// @luma.gl/core's log-level configuration now lives in the deckmap chunk's init
// (packages/components/deckmap/src/map-container.tsx), where luma is actually
// used, so map-less specs no longer pull luma-core into the eager entry chunk
// (EID-111).

const root = document.querySelector('#eidos');
const params = new URLSearchParams(window.location.search);
const id = params.get('id');

console.log('Eidos version ', version);

render(
  () => <Renderer id={id} onContextMenu={(e) => e.preventDefault()} />,
  root,
);
